export enum CivilStatus {
    Solteiro = 1,
    Casado = 2,
    Viuvo = 3,
    Divorciado = 4
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/CivilStatus.ts